import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 66 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#i563855527__a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#000",
    "fill-rule": "evenodd",
    d: "M65.604 15.922h-8.866c.209 2.085 1.76 2.754 3.52 2.754 1.804 0 3.256-.4 4.455-1.026v3.586a9.299 9.299 0 0 1-5.016 1.188c-4.411 0-7.513-2.7-7.513-8.078 0-4.526 2.629-8.122 6.93-8.122 4.312 0 6.556 3.542 6.556 8.1 0 .432-.044 1.36-.066 1.598m-6.512-6.07c-1.133 0-2.387.79-2.387 2.787h4.675c0-1.998-1.177-2.786-2.288-2.786M45.045 22.425c-1.584 0-2.552-.648-3.19-1.123l-.022 5-4.532.94V6.516h4.136l.088 1.101a5.222 5.222 0 0 1 3.553-1.393c3.19 0 6.182 2.808 6.182 7.992 0 5.648-2.97 8.208-6.215 8.208M44 10.166c-1.045 0-1.694.367-2.167.875l.022 6.61c.44.475 1.078.842 2.145.842 1.672 0 2.794-1.782 2.794-4.18 0-2.322-1.144-4.147-2.794-4.147m-12.936-3.65h4.543V22.11h-4.543zm0-5.076L35.607.5v3.629l-4.543.95V1.45zm-4.752 10.098V22.11H21.78V6.516h4.07l.132 1.317c1.1-1.911 3.377-1.523 3.982-1.317v4.093c-.572-.184-2.519-.465-3.652.929m-9.405 5.097c0 2.625 2.86 1.815 3.432 1.577v3.629c-.605.324-1.694.583-3.179.583a4.641 4.641 0 0 1-1.81-.312 4.572 4.572 0 0 1-1.54-.988 4.477 4.477 0 0 1-1.017-1.503 4.41 4.41 0 0 1-.33-1.776l.011-14.224 4.422-.929v3.824h3.454v3.812h-3.443v6.318zm-5.401.756c0 3.208-2.541 5.033-6.303 5.033A12.516 12.516 0 0 1 .297 21.42v-4.245c1.518.81 3.41 1.415 4.906 1.415 1.012 0 1.683-.26 1.683-1.08C6.886 15.372 0 16.17 0 11.246c0-3.143 2.508-5.022 6.182-5.022 1.496 0 2.992.216 4.499.81v4.19a10.302 10.302 0 0 0-4.51-1.144c-.946 0-1.584.27-1.584.972 0 1.998 6.919 1.047 6.919 6.35z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "i563855527__a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 .5h66v27H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }